<div class="vip-support-container">
  <div class="card border-0 shadow-sm">
    <!-- Header -->
    <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-2">
        <h2 class="card-title mb-0 fw-bold">VIP Support</h2>
      </div>
      <button
        #header_slideout_xbutton
        class="btn-close"
        kendoButton
        [svgIcon]="xIcon"
        (click)="cancel()"
        fillMode="flat"
        aria-label="Close"
      ></button>
    </div>

    <!-- Content -->
    <div>
      <!-- Navigation Header -->
      <div class="position-relative mb-4">
        @if (showBackButton) {
          <button
            kendoButton
            [svgIcon]="arrowLeftIcon"
            (click)="showLobbyButtons()"
            class="btn btn-outline-secondary position-absolute start-0 top-50 translate-middle-y"
            aria-label="Go back"
          ></button>
        }
        <h5 class="text-center mb-0 fw-semibold">Select a Support Option</h5>
      </div>

      <!-- Support Options -->
      @if (!showBackButton) {
        <div class="d-flex flex-column gap-3">
          <!-- Security Operations Center -->
          <div class="support-option">
            <button
              class="btn btn-outline-primary w-100 p-3 support-btn"
              kendoButton
              (click)="navigateToSection('lobby-1')"
            >
              <div class="support-content">
                <div class="support-icon">
                  <kendo-svg-icon
                    [icon]="lockIcon"
                    class="text-primary"
                  ></kendo-svg-icon>
                </div>
                <div class="support-text">
                  <h6>Security Operations Center</h6>
                  <p>For security incidents or escalation inquiries</p>
                  <span class="badge bg-success">24 hours a day, 7 days a week</span>
                </div>
              </div>
            </button>
          </div>

          <!-- Customer Success -->
          <div class="support-option">
            <button
              class="btn btn-outline-primary w-100 p-3 support-btn"
              kendoButton
              (click)="navigateToSection('csm')"
            >
              <div class="support-content">
                <div class="support-icon">
                  <kendo-svg-icon
                    [icon]="userIcon"
                    class="text-primary"
                  ></kendo-svg-icon>
                </div>
                <div class="support-text">
                  <h6>Customer Success</h6>
                  <p>For general support inquiries</p>
                  <span class="badge bg-info">Available Weekdays 9AM-5PM (EST)</span>
                </div>
              </div>
            </button>
          </div>

          <!-- ONE Product -->
          <div class="support-option">
            <button
              class="btn btn-outline-primary w-100 p-3 support-btn"
              kendoButton
              (click)="navigateToSection('one')"
            >
              <div class="support-content">
                <div class="support-icon">
                  <kendo-svg-icon
                    [icon]="checkIcon"
                    class="text-primary"
                  ></kendo-svg-icon>
                </div>
                <div class="support-text">
                  <h6>ONE Product</h6>
                  <p>For ONE product inquiries</p>
                  <span class="badge bg-info">Available Weekdays 9AM-5PM (EST)</span>
                </div>
              </div>
            </button>
          </div>

          <!-- Technical Operations -->
          <div class="support-option">
            <button
              class="btn btn-outline-primary w-100 p-3 support-btn"
              kendoButton
              (click)="navigateToSection('techops')"
            >
              <div class="support-content">
                <div class="support-icon">
                  <kendo-svg-icon
                    [icon]="gearIcon"
                    class="text-primary"
                  ></kendo-svg-icon>
                </div>
                <div class="support-text">
                  <h6>Technical Operations</h6>
                  <p>For deployment or technical security control inquiries</p>
                  <span class="badge bg-info">Available Weekdays 9AM-5PM (EST)</span>
                </div>
              </div>
            </button>
          </div>
        </div>
      }

      <!-- Roam Lobby Section -->
      @if (showBackButton) {
        <div class="mt-4">
          <div id="roam-lobby"></div>
        </div>
      }
    </div>
  </div>
</div>
